import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cn from 'classnames';
import { openFullscreenPreview } from '../../store/actions';

import Conversation from './components/Conversation';
import Launcher from './components/Launcher';
import FullScreenPreview from './components/FullScreenPreview';

import '../../../../styles.css';

const WidgetLayout = ({
  title,
  titleAvatar,
  subtitle,
  onSendMessage,
  onToggleConversation,
  senderPlaceHolder,
  onQuickButtonClicked,
  profileAvatar,
  profileClientAvatar,
  showCloseButton,
  fullScreenMode,
  config,
  autofocus,
  customLauncher,
  onTextInputChange,
  chatId,
  launcherOpenLabel,
  launcherCloseLabel,
  launcherCloseImg,
  launcherOpenImg,
  sendButtonAlt,
  showTimeStamp,
  imagePreview,
  zoomStep,
  showBadge,
  resizable,
  emojis,
  showStartScreen,
  onSubmit
}) => {
  const dispatch = useDispatch();
  const { disableInput, showChat, visible, isChatFullScreen } = useSelector((state) => ({
    showChat: state.behavior.showChat,
    disableInput: state.behavior.disabledInput,
    visible: state.preview.visible,
    isChatFullScreen: state.messages.isChatFullScreen,
  }));

  const messageRef = useRef(null);

  useEffect(() => {
    if (showChat) {
      messageRef.current = document.getElementById('messages');
    }
    return () => {
      messageRef.current = null;
    };
  }, [showChat]);

  const eventHandle = (evt) => {
    if (evt.target && evt.target.className === 'rcw-message-img') {
      const { src, alt, naturalWidth, naturalHeight } = evt.target;
      const obj = {
        src: src,
        alt: alt,
        width: naturalWidth,
        height: naturalHeight
      };
      dispatch(openFullscreenPreview(obj));
    }
  };

  useEffect(() => {
    const target = messageRef?.current;

    if (imagePreview && showChat) {
      target?.addEventListener('click', eventHandle, false);
    }

    return () => {
      target?.removeEventListener('click', eventHandle);
    };
  }, [imagePreview, showChat]);

  useEffect(() => {
    document.body.setAttribute(
      'style',
      `overflow: ${visible || fullScreenMode ? 'hidden' : 'auto'}`
    );
  }, [fullScreenMode, visible]);
  return (
    <div
      className={cn('rcw-widget-container', {
        'rcw-full-screen': fullScreenMode,
        'rcw-previewer': imagePreview,
        'rcw-close-widget-container': !showChat,
        'rcw-chat-full-screen': isChatFullScreen
      })}>
      {showChat && (
        <Conversation
          title={title}
          subtitle={subtitle}
          sendMessage={onSendMessage}
          senderPlaceHolder={senderPlaceHolder}
          profileAvatar={profileAvatar}
          profileClientAvatar={profileClientAvatar}
          toggleChat={onToggleConversation}
          showCloseButton={showCloseButton}
          disabledInput={disableInput}
          autofocus={autofocus}
          config={config}
          titleAvatar={titleAvatar}
          className={showChat ? 'active' : 'hidden'}
          onQuickButtonClicked={onQuickButtonClicked}
          onTextInputChange={onTextInputChange}
          sendButtonAlt={sendButtonAlt}
          showTimeStamp={showTimeStamp}
          resizable={resizable}
          emojis={emojis}
          showStartScreen={showStartScreen}
          onSubmit={onSubmit}
        />
      )}
      {customLauncher
        ? customLauncher(onToggleConversation)
        : !fullScreenMode && (
          <Launcher
            toggle={onToggleConversation}
            chatId={chatId}
            openLabel={launcherOpenLabel}
            closeLabel={launcherCloseLabel}
            closeImg={launcherCloseImg}
            openImg={launcherOpenImg}
            showBadge={showBadge}
          />
        )}
      {imagePreview && <FullScreenPreview fullScreenMode={fullScreenMode} zoomStep={zoomStep} />}
    </div>
  );
};

export default WidgetLayout;
